import equal from 'fast-deep-equal';
import _ from 'lodash';

const diffBy = (pred) => (a, b) => a.filter((x) => !b.some((y) => pred(x, y)));
const compare = (arr1, arr2, by) => {
  const pred = (x, y) => {
    return equal(x, y);
  };

  const results = [];
  _.forEach(arr1, (a) => {
    const found = _.find(arr2, (a2) => {
      const a1Hash = !!a[by] ? { ...a, [by]: [] } : a;
      const a2Hash = !!a2[by] ? { ...a2, [by]: [] } : a2;
      return equal(a1Hash, a2Hash);
    });
    if (!found) {
      results.push(a);
    } else {
      if (!!by) {
        const diffData = diffBy(pred)(a[by], found[by]);
        if (diffData.length) {
          results.push({
            ...a,
            [by]: diffData,
          });
        }
      } else {
        return diffBy(pred)(a, found);
      }
    }
  });
  return results;
};

export function getDiff(arr1 = [], arr2 = [], byProp) {
  const a1 = _.cloneDeep(arr1);
  const a2 = _.cloneDeep(arr2);
  const result = {
    arr1: compare(a1, a2, byProp),
    arr2: compare(a2, a1, byProp),
  };

  return result;
}

export default {
  getDiff,
};
